import {
  login,
  logout,
  getInfo
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  resolve
} from 'path'
import {
  reject
} from 'q'

const user = {
  state: {
    skuList: [],
    multipleList: [], // 所选商品缓存，方便切换页面
    skuGiftList: [],
    skuActiveList: [],
    skuGiftActiveList: [],
    skuRankActiveList: [],
    couponObj: {},
    tableTabs: [],
    isFromAddActive: null,
    isDestroyDetailPic: 'no',
    whichLevel: null,
    activeSkuOrSkuGift: null,
    token: getToken(),
    shopId: sessionStorage.getItem('SHOP_ID') || '',
    name: '',
    avatar: '',
    roles: [],
    merchantId: '', //  判断是否是商家端 小于1是运营端
    brandList: '',
    isAddShop: 'no',
    couponNumAll1: '',
    shipTabType: {
      one: '',
      two: '',
      three: '',
      four: '',
      five: '',
    },
    // taglist 顶部路由列表
    taglistNew: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_TAGLISTNEW: (state, taglistNew) => {
      state.taglistNew = taglistNew
    },
    SET_COUPONNUMALL: (state, couponNumAll1) => {
      state.couponNumAll1 = couponNumAll1;
    },
    SET_SHIPTABTYPE: (state, shipTabType) => {
      state.shipTabType = shipTabType;
    },
    SET_COUOBJ: (state, couponObj) => {
      state.couponObj = couponObj
    },
    SET_ISFROMACTIVE: (state, isFromAddActive) => {
      state.isFromAddActive = isFromAddActive
    },
    SET_ISDESTROYPIC: (state, isDestroyDetailPic) => {
      state.isDestroyDetailPic = isDestroyDetailPic;
      console.log(isDestroyDetailPic, 'isDestroyDetailPic--1')
    },
    SET_SKULIST: (state, skuList) => {
      state.skuList = skuList
    },
    SET_MULTIPLELIST: (state, multipleList) => {
      state.multipleList = multipleList
    },
    SET_SKUGIFTLIST: (state, skuGiftList) => {
      state.skuGiftList = skuGiftList
    },
    SET_WHICHLEVEL: (state, whichLevel) => {
      state.whichLevel = whichLevel
    },
    SET_WHICHACTIVE: (state, activeSkuOrSkuGift) => {
      state.activeSkuOrSkuGift = activeSkuOrSkuGift
    },
    SET_SKUGIFTACTIVELIST: (state, skuGiftActiveList) => {
      state.skuGiftActiveList = skuGiftActiveList
    },
    SET_SKUACTIVELIST: (state, skuActiveList) => {
      state.skuActiveList = skuActiveList
    },
    SET_SKURANKACTIVELIST: (state, skuRankActiveList) => {
      state.skuRankActiveList = skuRankActiveList
    },
    SET_TABLETABS: (state, tableTabs) => {
      state.tableTabs = tableTabs
    },
    SET_SHOP_ID: (state, shopId) => {
      state.shopId = shopId
    },
    SET_ADD_SHOP: (state, isAddShop) => {
      state.isAddShop = isAddShop
    },
    SET_BRAND_LIST: (state, brandList) => {
      state.brandList = brandList
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_MERCHANTID: (state, merchantId) => {
      state.merchantId = merchantId
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    getShopId({
      commit
    }, shopId) {
      return new Promise(resolve => {
        commit('SET_SHOP_ID', shopId)
        resolve()
      })
    },
    getSkuList({
      commit
    }, skuList) {
      return new Promise(resolve => {
        commit('SET_SKULIST', skuList)
        resolve()
      })
    },
    getBrandList({
      commit
    }, brandList) {
      return new Promise(resolve => {
        commit('SET_BRAND_LIST', brandList)
        resolve()
      })
    },

    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data;
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_MERCHANTID', data.merchantId)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js